import { Component, OnInit, Input } from '@angular/core';
import { WindowMode } from 'src/app/enums/window-mode.enum';
import { CreditLine } from 'src/app/models/credit-line.model';
import { FinancingService } from 'src/app/services/financing.service';
import { CommonService } from 'src/app/services/common.service';
import { Subscription } from 'rxjs';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { Router } from '@angular/router';
import { Account } from 'src/app/models/account.model';

@Component({
  selector: 'app-credit-line',
  templateUrl: './credit-line.component.html',
  styleUrls: ['./credit-line.component.scss']
})
export class CreditLineComponent implements OnInit {
  catalogUrl = '/ofivirtual/tienda'
  /*Modo de ventana actual */
  @Input() currentWindowMode: number;
  /*Modos de ventana disponible */
  windowModeList = WindowMode;
  /*Suscripción a observable de cuenta seleccionada */
  accountSelectedSubscription: Subscription;
  /**Subscripción a observable de linea de crédito actualizada */
  creditLineUpdatedSubscription: Subscription;
  creditLine = new CreditLine();
  selectedAccount: Account;
  constructor(private financingService: FinancingService,
    private commonService: CommonService,
    private virtualStoreService: VirtualStoreService,
    private router: Router) {
    this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced.subscribe(account => {
      this.selectedAccount = account;
      this.loadCreditLine(account.clientCode);
    });

    if (this.router.url.startsWith(this.catalogUrl)) {

      this.creditLineUpdatedSubscription = this.virtualStoreService.creditLineUpdatedAnnounced.subscribe(creditLine => {
        this.updateCreditLine(creditLine);
      });
    }
  }

  ngOnInit() {
    if (this.currentWindowMode == null) { this.currentWindowMode = this.windowModeList.Normal; }
  }
  ngOnDestroy() {
    if (this.accountSelectedSubscription) this.accountSelectedSubscription.unsubscribe();
    if (this.creditLineUpdatedSubscription) this.creditLineUpdatedSubscription.unsubscribe();
  }
  simulateCreditLine() {
    this.creditLine.usedAmount = this.creditLine.usedAmount + this.creditLine.shoppingCartAmount;
    this.creditLine.availableAmount = this.creditLine.availableAmount - this.creditLine.shoppingCartAmount;
    this.creditLine.usedAmountRate = this.rateAmount();
    }
  loadCreditLine(clientCode: string) {
    this.financingService.getCreditLine(clientCode).subscribe(response => {
      this.creditLine = response.data;
      this.creditLine.usedAmountRate = this.rateAmount();
      if (this.router.url.startsWith(this.catalogUrl)) this.simulateCreditLine();
    });
  }
  updateCreditLine(creditLine: CreditLine) {
    this.creditLine = creditLine;
    this.creditLine.usedAmountRate = this.rateAmount();
    if (this.router.url.startsWith(this.catalogUrl)) this.simulateCreditLine();
  }
  rateAmount():number{
    if(this.creditLine.approvedAmount==0) return 0;
    return this.creditLine.usedAmount/this.creditLine.approvedAmount*100;
  }
}
